// @flow
import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import moment from "moment";
import LazyLoad from "react-lazyload";
import TextTruncate from "react-text-truncate";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import CONFIG from "../../../config";
import Checkbox from "../../common/checkbox/Checkbox";
import styles from "./ProductListBox.scss";

const ProductListBox = (props: Object) => {
  const offer = props.offer;
  const placeholder = (
    <img
      src={`${CONFIG.BASE_IMG_URL}nr/misc/product-image-default.jpg`}
      alt="Placeholder"
    />
  );
  return (
    <div className={`${styles.ctr} ${props.checked ? styles.checked : ""}`}>
      <div className={styles.checkboxWrapper}>
        <Checkbox
          onClick={() => props.onClickCheckbox()}
          checked={props.checked}
          name={`listbox${props.index}`}
        />
      </div>
      <div
        className={styles.productWrapper}
        onClick={() => props.offersNav(offer.offer_code)}
      >
        <div className={styles.imageSection}>
          <div className={styles.imageNameWrapper}>
            {offer.image_key ? (
              <div className={styles.imageCtr}>
                <LazyLoad
                  height="100%"
                  once
                  placeholder={placeholder}
                  offset={100}
                >
                  <img src={Helper.getTransformationUrl(offer.image_key)} />
                </LazyLoad>
              </div>
            ) : (
              ""
            )}
            <div className={styles.names}>
              {offer.title ? (
                <TextTruncate
                  line={2}
                  text={offer.title}
                  containerClassName={styles.productName}
                />
              ) : (
                ""
              )}
              {offer.brand ? (
                <div className={styles.brand}>
                  {offer.brand}
                  {offer.variant ? (
                    <span className={styles.attr}>
                      {I18n.getHtml(
                        "product-table.variant",
                        { variant: offer.variant },
                        "<a>Variant:</a> {variant}"
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                  {offer.attributes &&
                  !_.isEmpty(JSON.parse(offer.attributes)) &&
                  JSON.parse(offer.attributes).colour_family ? (
                    <span className={styles.attr}>
                      {I18n.getHtml(
                        "product-table.color",
                        { color: JSON.parse(offer.attributes).colour_family },
                        "<a>Color:</a> {color}"
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className={styles.statusCtr}>
            {offer ? (
              <div
                className={
                  Number(offer.is_active) ? styles.active : styles.inactive
                }
              >
                {Number(offer.is_active)
                  ? I18n.getText("product-table.active", {}, "Active")
                  : I18n.getText("product-table.inactive", {}, "Inactive")}
              </div>
            ) : (
              ""
            )}
            <div className={styles.date} style={{ direction: "ltr" }}>
              {offer.updated_at
                ? moment(offer.updated_at).format(
                    `YYYY-MM-DD [${props.lang === "ar" ? "" : "at"}] h:mm:ss a`
                  )
                : ""}
            </div>
          </div>
        </div>
        <div className={styles.descCtr}>
          <div className={styles.attrCtr}>
            <div className={styles.eachAttr}>
              <h6 className={styles.attrTitle}>
                {I18n.getText("product-table.p-sku", {}, "Partner SKU")}
              </h6>
              <div className={styles.attrVal}>
                {(offer && offer.partner_sku) || ""}
              </div>
            </div>
            <div className={styles.eachAttr}>
              <h6 className={styles.attrTitle}>
                {I18n.getText("product-table.sku", {}, "SKU")}
              </h6>
              <div className={styles.attrVal}>{(offer && offer.sku) || ""}</div>
            </div>
            <div className={styles.eachAttr}>
              <h6 className={styles.attrTitle}>
                {I18n.getText("product-table.stock", {}, "Stock")}
              </h6>
              <div className={styles.attrVal}>
                {(offer && offer.stock_available) || ""}
              </div>
            </div>
          </div>
          <div className={styles.priceWrapper}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("product-table.price", {}, "Price")}
            </h6>
            <div className={styles.attrVal}>
              {offer && offer.sale_price ? (
                <div>
                  {I18n.formatCurrency(
                    Helper.formatPrice(offer.sale_price, props.currencyCode)
                  )}
                </div>
              ) : (
                ""
              )}
              {offer && offer.price ? (
                <div className={offer.sale_price ? styles.strike : ""}>
                  {I18n.formatCurrency(
                    Helper.formatPrice(offer.price, props.currencyCode)
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className={styles.date}>
              {offer && offer.updated_at
                ? moment(offer.updated_at).format("YYYY-MM-DD [at] h:mm:ss a")
                : ""}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProductListBox.propTypes = {};

ProductListBox.getDefaultProps = {};

export default ProductListBox;



// WEBPACK FOOTER //
// ./src/components/products/productListBox/ProductListBox.js